module.exports = __webpack_public_path__ + "static/media/AutoHubSpinnerLogo.849f5bca.gif";